import React, { FC } from 'react';
import { ApiContext, ApiContextProps } from './ApiContext';
import { getApiHost } from './Api';

const ApiProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
  const api: ApiContextProps = { api:getApiHost() };
  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
};

export { ApiProvider };